"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterEffectSchemaObject = exports.alignmentSchemaField = exports.fittingSchemaField = exports.fitting = exports.align = void 0;
var yup = __importStar(require("yup"));
exports.align = __spreadArray([], [
    'top',
    'bottom',
    'left',
    'right',
    'center',
    'top left',
    'top right',
    'bottom left',
    'bottom right',
]);
exports.fitting = __spreadArray([], [
    'fill',
    'fit',
    'stretch',
    'actual_size',
    'original_size',
    'tile',
    'tile_horizontal',
    'tile_vertical',
    'fit_and_tile',
    'legacy_tile',
    'legacy_tile_horizontal',
    'legacy_tile_vertical',
    'legacy_normal',
]);
exports.fittingSchemaField = {
    fittingType: yup.mixed().oneOf(exports.fitting).default(exports.fitting[0]),
};
exports.alignmentSchemaField = {
    alignType: yup.mixed().oneOf(exports.align).default(exports.align[0]),
};
exports.filterEffectSchemaObject = yup.object({
    effectType: yup.string(),
    brightness: yup.number().min(0).max(10),
    contrast: yup.number().min(0).max(10),
    saturation: yup.number().min(0).max(10),
    hue: yup.number().min(-180).max(180),
    duotoneDark: yup.string(),
    duotoneLight: yup.string(),
    invert: yup.boolean().default(false),
    isCustom: yup.boolean(),
});
//# sourceMappingURL=mediaCommon.schema.js.map